import { csvTemplates, SupportedLanguage, TemplateType } from './index';

/**
 * Loads a CSV template for a specific language and template type
 * @param language - The language code (en, es, pt)
 * @param templateType - The type of template (blocks, residents, etc.)
 * @returns Promise<string> - The CSV content as a string
 */
export async function loadCSVTemplate(language: SupportedLanguage, templateType: TemplateType): Promise<string> {
  try {
    const templatePath = csvTemplates[language][templateType];
    const response = await fetch(templatePath);
    
    if (!response.ok) {
      throw new Error(`Failed to load template: ${response.statusText}`);
    }
    
    return await response.text();
  } catch (error) {
    console.error(`Error loading CSV template for ${language}/${templateType}:`, error);
    // Fallback to English template if the requested language fails
    if (language !== 'en') {
      return loadCSVTemplate('en', templateType);
    }
    throw error;
  }
}

/**
 * Gets the available template URL for a specific language and template type
 * @param language - The language code (en, es, pt)
 * @param templateType - The type of template (blocks, residents, etc.)
 * @returns string - The template URL
 */
export function getTemplateURL(language: SupportedLanguage, templateType: TemplateType): string {
  return csvTemplates[language][templateType];
}

/**
 * Gets the default language (English) template URL
 * @param templateType - The type of template (blocks, residents, etc.)
 * @returns string - The English template URL
 */
export function getDefaultTemplateURL(templateType: TemplateType): string {
  return csvTemplates.en[templateType];
}
